import State from './State';
import Role from '../../domain/Role';
import sampleData from '../account/sampleData';

const initialState: State = {
    customerId: '',
    name: '',
    liabilityRate: 0,
    errorMessage: '',
    role: Role.Null,
    shippingAddress: sampleData.shippingAddress,
    billingAddress: sampleData.billingAddress,
    discountRate: 0,
    shippingMethod: '',
    email: '',
    initialLocation: {
        pathname: '/'
    }
};

export default initialState;



// WEBPACK FOOTER //
// ./src/application/user/initialState.ts